import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import {addSuccessMessage} from "../SnackBar";

export const REFEREE_PATCH_REQUEST = 'PATCH_REFEREE_REQUEST';
export const REFEREE_PATCH_FAILURE = 'PATCH_REFEREE_FAILURE';
export const REFEREE_PATCH_SUCCESS = 'PATCH_REFEREE_SUCCESS';

export const patchReferee = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.REFEREE.PATCH, data, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSuccess(response.data));
                dispatch(addSuccessMessage('Referee successfully changed'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => {
    return { type: REFEREE_PATCH_REQUEST }
};

const postFailure = (error) => {
    return { type: REFEREE_PATCH_FAILURE, error }
};

const patchSuccess = referee => {
    return { type: REFEREE_PATCH_SUCCESS, referee }
};